import React, { Component } from 'react';
import { Error404 } from "../common/SVG";
import { Link } from "react-router-dom";
import {FormattedMessage} from "react-intl";

class NoMatch extends Component{
	render(){
		const { localizePath } = this.props;
		return (
			<div className="container-flex">
				<h2 className="page__title page__title--404"/>
				<div className="page">
					<div className="page__content page__content--404">
						<div className="error-404__symbol">
							<Error404 />
						</div>
						<h2 className="error-404__title">
							<FormattedMessage id={'amikohome.error-404.message'} />
						</h2>
						<div className="error-404__link">
							<Link to={localizePath('/')}>
								<FormattedMessage id={'amikohome.error-404.return-to-homepage'} />
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/error/NoMatch.js